import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { remove } from '@mailobj-browser/front/js/tree/tree.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { get } from '#utilities/js/ea/ajax.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault,
  ]),
  task: async (button) => {
    const { formAction } = button
    const li = closest('li', button)
    let promise = get(formAction, { target: button })

    queueMicrotask(async () => {
      await wait(1000)

      if (promise) {
        removeMessage(li)
      }
    })

    await promise
    promise = null
    removeMessage(li)
  }
})

export const removeMessage = (li) => {
  remove(li)
}

export default button => {
  onClick.listen(button)
}
